import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import request from '../../helpers/request';
import SimplePage from '../common/SimplePage';
import vendorConfig from './config/vendorConfig';
import setViewTitle from '../../helpers/setViewTitle';
import setVisibility from '../../helpers/setVisibility';

var Vendor = createReactClass({

  getInitialState() {
    return {
      hasBeenFound: false,
      vendor: {},
      actions: []
    };
  },

  componentWillMount() {
    setViewTitle('Lieferantenkarte');
  },

  componentDidMount() {
    request.get({
      url: vendorConfig.apiUrl + this.props.match.params.vendorId,
      success: data => {
        if (this.isMounted()) {
          this.setState({
            hasBeenFound: true,
            vendor: data
          }, () => {
            var actions = [];

            if (! this.state.vendor.isSyncVendor) {
              actions.push({title: 'Lieferant bearbeiten', to: `/vendors/edit/${this.props.match.params.vendorId}`, claim: 'vendors:write'});
            }

            this.setState({
              actions: actions
            });
          });
        }
      }
    });
  },

  render() {
    let { hasBeenFound, vendor, actions } = this.state;

    let createdBy = vendor.isSyncVendor ? `${vendor.syncName} (${vendor.syncKey})` : 'Lagerpark';

    return (
        <div style={setVisibility(hasBeenFound)}>
          <SimplePage title={vendor.name} icon="paper-plane-o" actions={actions}>
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <tbody>
                  <tr><td width="35%">Name</td><td width="65%">{vendor.name}</td></tr>
                  <tr><td width="35%">Angelegt in</td><td width="65%">{createdBy}</td></tr>
                  <tr><td width="35%">Letzter Import</td><td width="65%">{this.getDateString(vendor.lastImportDate)}</td></tr>
                </tbody>
              </table>
            </div>
            <div className="smart-form">
              <footer>
                <Link to="/vendors" className="btn btn-default">Zurück</Link>
              </footer>
            </div>
          </SimplePage>
        </div>
    );
  },

  getDateString(jsonDate) {
    if (! jsonDate) {
      return;
    }


    var date = new Date(jsonDate);
    var day = date.getDate();
    var month = date.getMonth() +1;
    var year = date.getFullYear();

    return day.toString(10) + '.' + month.toString(10) + '.' + year.toString(10);
  }

});

export default Vendor;



// WEBPACK FOOTER //
// ./src/components/vendors/VendorCard.js